import { render, staticRenderFns } from "./IndustryStructure.vue?vue&type=template&id=74a0d1e8"
import script from "./IndustryStructure.vue?vue&type=script&lang=js"
export * from "./IndustryStructure.vue?vue&type=script&lang=js"
import style0 from "./IndustryStructure.vue?vue&type=style&index=0&id=74a0d1e8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports